import Link from "next/link";
import Image from "next/image";
import LogoSmallImage from "../../../../public/images/logo_small_white.svg";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";


const RegionCardWrapper = styled.div`
    margin:10px;
    cursor: pointer;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    background-image: url("${props => props.$image }");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    color:white;
    
    :hover{
        .background_image{
            transform: scale(1.05);
            transition: ease-in-out 0.3s;    
        }
    }

    .background_image{
        width: 370px;
        height: 500px;
        object-fit: cover;
    }
    
    @media only screen and (${breakpoints.mobile}) {
        .background_image{
            width: 300px;
            height: 400px;
        }
        
    }
`;

export default function RegionCard({item, showNumOfCities = true}) {
    return <ForceSSRLink prefetch={false} style={{textDecoration:'none', all:'unset'}} href={item?.slug ?? '#'}>
        <RegionCardWrapper $image={item?.homepageImage?.url}>

            <Image
                className={'background_image'}
                src={item?.homepageImage?.url}
                alt={item?.name}
                width={370}
                height={500}
            />

            <div
                style={{
                    position:'absolute',
                    bottom:0,
                    display:'flex',
                    gap:!showNumOfCities ? '15px' : '10px',
                    alignItems:'center',
                    flexDirection:'column',
                    marginBottom:'30px',
                }}
            >
                <Image src={LogoSmallImage} alt={'Secret Food Tours'}/>
                {
                    showNumOfCities && <div style={{
                        fontSize:'16px',
                    }}>{item?.numOfCities} Cities</div>
                }

                <div style={{
                    fontSize: '36px',
                }}>{item?.name}</div>
            </div>

        </RegionCardWrapper>
    </ForceSSRLink>
}
